module.exports = __webpack_public_path__ + "static/media/Gord Kurtenbach.417890d5.png";